import React, { useEffect, useState, useRef, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

import toastr from "../../utils/toast";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { MaterialReactTable } from "material-react-table";
import { openInAppTab } from "../../utils/tabNavigation";

function SearchMapping() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const navigate = useNavigate();

  const { setGlobalLoading, token } = useOutletContext();
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const [roles, setRoles] = useState("");
  const [options, setOptions] = useState([]);
  const [myroles, setmyroles] = useState([]);
  const [selectedmyroles, setselectedmyroles] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [arr, setArr] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const onSubmit = async (data) => {
    console.log(data);
    try {
      setGlobalLoading(true);
      const candidates = await axios.post(
        `${API_BASE_URL}/ai_candidates/get_role_map_candidates`,
        {
          compensation: data.compensation,
          role_id: data.role_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (candidates.status === 200) {
        if (candidates.data.candidates.length === 0) {
          setmyroles([]);
          setOptions([]);
          setArr(true);
        } else {
          setOptions(candidates.data.candidates);

          const my_roles = await axios.get(
            `${API_BASE_URL}/common_controller/get_my_roles`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (my_roles.data.options.length > 0) {
            setmyroles(my_roles.data.options);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setGlobalLoading(true);
    } finally {
      setGlobalLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Full Name",
        accessorKey: "full_name",
        Cell: ({ row }) => (
          <div className="d-flex align-items-center">
            <Link
              to={`/candidates/view/${row.original.id}`}
              target="_blank"
              className="avatar avatar-md border avatar-rounded"
              onClick={(event) => {
                event.preventDefault();
                openInAppTab(
                  `/candidates/view/${row.original.id}`,
                );
              }}
            >
              <img
                src={
                  row.original.userpic
                    ? `${PINE_BASE_URL}/files/candidates/picture/${row.original.userpic}`
                    : `${PINE_BASE_URL}/files/candidates/picture/no-pic.png`
                }
                className="img-fluid"
                alt="img"
              />
            </Link>
            <div className="ms-2 d-flex">
              <h6 className="fw-medium fs-12 mbm-12">
                <Link
                  to={`/candidates/view/${row.original.id}`}
                  target="_blank"
                  onClick={(event) => {
                    event.preventDefault();
                    openInAppTab(
                      `/candidates/view/${row.original.id}`,
                    );
                  }}
                >
                  {row.original.full_name}
                </Link>
              </h6>
              {row.original.linkdin_url && (
                <a
                  className="ms-2"
                  target="_blank"
                  href={row.original.linkdin_url}
                >
                  <i className="fa-brands fa-linkedin"></i>
                </a>
              )}
            </div>
          </div>
        ),
      },
      { header: "Email", accessorKey: "email" },
      {
        header: "Phone",
        accessorKey: "phone",
        Cell: ({ row }) => row.original.phone || row.original.mobile || "",
      },
      { header: "Industry", accessorKey: "industrymaster" },
      { header: "Function", accessorKey: "dutymaster" },
      { header: "Company", accessorKey: "current_company" },
      { header: "Designation", accessorKey: "designation" },
      { header: "Currency", accessorKey: "currency" },
      { header: "Compensation", accessorKey: "compensation" },
      { header: "Country", accessorKey: "country_name" },
      { header: "City", accessorKey: "city" },
    ],
    [],
  );

  const defaultColDef = useMemo(() => {
    return {
      floatingFilter: true,
    };
  }, []);

  useEffect(() => {
    async function get_roles() {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/common_controller/get_active_roles_list_with_jd`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.options.length > 0) {
          setRoles(response.data.options);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    }

    get_roles();

    const $selectRole = $("select[name='role_id']");

    $selectRole.select2({
      placeholder: "Select Active Role",
      width: "100%",
      closeOnSelect: false,
    });

    $selectRole.on("change", function (e) {
      const selectedValues = $(this).val();
      //   handleFileChange({ target: { value: selectedValues } });
      setValue("role_id", selectedValues);
    });

    return () => {
      $selectRole.select2("destroy");
    };
  }, [token]);

  useEffect(() => {
    const $selectMyroles = $("select[name='myroles']");
    $selectMyroles.select2({
      placeholder: "Select the role you are working on",
    });

    $selectMyroles.on("change", function (e) {
      const selectedValues = $(this).val();
      if (selectedValues.length > 0) {
        $("#discard_candidates").removeClass("hide");
        setselectedmyroles(selectedValues);
      } else {
        $("#discard_candidates").addClass("hide");
        setselectedmyroles([]);
      }
      setValue("myroles", selectedValues || []); // update react-hook-form
    });

    return () => {
      $selectMyroles.select2("destroy");
    };
  }, [myroles]);

  const onSubmitmyroles = async (data) => {
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/ai_candidates/get_role_map_candidates`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.candidates.length > 0) {
        setOptions(response.data.candidates);
      } else {
        setOptions([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    const ids = options
      .filter((row) => rowSelection[row.id])
      .map((row) => row.id);

    setSelectedIds(ids);
  }, [rowSelection, options]);

  useEffect(() => {
    setRowSelection({});
  }, [options]);

  const mapCandidates = async (formData) => {
    if (!selectedmyroles || selectedmyroles.length === 0) {
      // Show error, focus the select2, and stop
      const $selectMyroles = $("select[name='myroles']");

      alert("Please select the role you are working on");
      // Focus on the select2 dropdown
      $selectMyroles.select2("open");

      return; // Prevent further processing
    }

    const data = {
      selectedId: selectedIds,
      selectedRole: selectedmyroles,
    };
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/ai_candidates/map_to_role`,
        {
          data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success == true) {
        setOptions((prevOptions) =>
          prevOptions.filter((item) => !selectedIds.includes(item.id)),
        );
        setRowSelection({});
        setSelectedIds([]);
        toastr.success(response.data.message);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }

    // Proceed with mapping logic here
  };

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Search Mapping</h2>
            <p className="fs-12">
              Select the role(s) you wish to map candidates to your workstation
              for.
            </p>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Roles &nbsp;
                      <span className="text-danger">
                        * {errors.role_id && errors.role_id.message}
                      </span>
                    </label>
                    <select
                      {...register("role_id", {
                        required: "Required",
                      })}
                      multiple
                      className="form-select"
                    >
                      <option></option>
                      {roles.length > 0
                        ? roles.map((value, index) => (
                            <option key={index} value={value.value}>
                              {value.label}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      &nbsp;
                      <span className="text-danger">
                        {errors.compensation && errors.compensation.message}
                      </span>
                    </label>
                    <br />
                    <input type="checkbox" {...register("compensation")} /> View
                    Candidates with compensation
                  </div>
                </div>
              </div>
              <div className="text-end row">
                <div className="offset-md-9 col-md-3">
                  <button type="submit" className="btn btn-primary">
                    Search Candidates
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {myroles && myroles.length > 0 ? (
          <form onSubmit={handleSubmit(onSubmitmyroles)}>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <select
                      {...register("myroles")}
                      className="form-select select2"
                      style={{ width: "44.917px" }}
                    >
                      <option value={""}>
                        Select the role you are working on
                      </option>
                      {myroles.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-8">
                    <button
                      className="btn btn-info hide fs-10"
                      id="discard_candidates"
                      type="submit"
                    >
                      <i className="fe fe-eye-off"></i> Exclude candidates of
                      workstation
                    </button>
                    {selectedIds.length > 0 && (
                      <a
                        href="#"
                        className="btn btn-success fs-10 ms-2"
                        onClick={handleSubmit(mapCandidates)}
                      >
                        <i className="ti ti-checks"></i> Add candidates to
                        workstation
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        ) : (
          ""
        )}
        <div className="card">
          <div className="card-body">
            <h5 className="mb-3">Search result</h5>
            <div className="row">
              <div className="col-md-12 text-center">
                {options.length > 0 ? (
                  <MaterialReactTable
                    key={options.length}
                    columns={columns}
                    data={options}
                    getRowId={(row) => row.id}
                    enableRowSelection
                    enablePagination
                    enableColumnFilters
                    enableSorting
                    onRowSelectionChange={setRowSelection}
                    state={{ rowSelection, columnFilters: [] }}
                    initialState={{
                      pagination: { pageSize: 50 },
                    }}
                  />
                ) : (
                  <>
                    <img
                      width={"16%"}
                      src="..\assets\img\icons\people_search_icon.png"
                    />
                    <p>
                      <b>
                        {arr === true
                          ? "No Candidate found."
                          : "No candidates yet! Select Roles for personalised results."}
                      </b>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// function debounce(func, delay) {
//   let timer;
//   return (...args) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => func(...args), delay);
//   };
// }

export default SearchMapping;
